import { Button, styled } from '@mui/material';

export const LabelButton = styled(Button)(() => ({
	textTransform: 'capitalize',
	width: '100%',
}));
